import { AuthEffects } from './../component/auth/state/auth.effects';
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { User } from '../component/auth/model/user.model';
import { AuthActions } from '../component/auth/state/action-types';
import { getUser, isLoggedIn } from '../component/auth/state/auth.selectors';
import { AppState } from '../reducers';

@Injectable({
    providedIn: 'root'
})
export class LoginTokenService {
    retUser: User = new User();
    constructor(private store: Store<AppState>, private authEffects: AuthEffects) {}

    isLoggedIn(): Observable<boolean> {
        return this.authEffects.isLoggedIn$;
    }

    public getUser(): User {
        this.isLoggedIn().subscribe((x) => {
            if (x) {
                this.store.pipe(select(getUser)).subscribe((user) => {
                    this.retUser = user!!;
                });
            }
        });
        return this.retUser;
    }

    public logout() {
        this.store.dispatch(AuthActions.logout());
    }
}
